// @flow
export const CHANGE_TO_NEXT_VIEW = 'CHANGE_TO_NEXT_VIEW';
export const MONITORING_DATA_RECEIVED = 'MONITORING_DATA_RECEIVED';
export const RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND';

export const INITIAL_RENDER = 'INITIAL_RENDER';
